export default __webpack_public_path__ + "static/media/illustration-compte.44372c18.png";